<template>
  <v-dialog v-model="dialogOpen" :persistent="true" max-width="600px">
    <v-form>
      <v-card>
        <v-card-title>
          <h2><v-icon>folder</v-icon> Gerät</h2>
        </v-card-title>
        <v-card-text>
          <v-text-field v-model="shortName" label="Kurzbezeichnung" hint="Die Kurzbezeichnung wird vor der Bezeichnung angezeigt" />
          <v-text-field
            v-model="name"
            label="Bezeichnung"
            :rules="rules"
            required
          />
          <v-textarea label="Beschreibung" v-model="description" />
        </v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn color="default" text @click="close" :disabled="actionsDisabled">Abbrechen</v-btn>
          <v-btn v-if="isExistingTool && tool.isActive" color="error" class="white--text" @click="setInactive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye-off</v-icon> Deaktivieren
          </v-btn>
          <v-btn v-else-if="isExistingTool" color="success" class="white--text" @click="setActive" :loading="isChangingActive" :disabled="actionsDisabled">
            <v-icon>mdi-eye</v-icon> Aktivieren
          </v-btn>
          <v-btn color="primary" @click="save" :disabled="!valid || actionsDisabled" :loading="isSaving">Speichern</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import timeparkApi from "@/timeparkApi";
const machinesApi = timeparkApi.machinesApi;

export default {
  name: 'ToolDialog',
  props: {
    open: Boolean,
    tool: Object,
    machineId: String,
  },
  computed: {
    dialogOpen: {
      get() {
        return this.open;
      },
      set(v) {
        this.$emit('update:open', v);
      }
    },
    isChangingActive() {
      return this.runningOperation === 'changeActive';
    },
    isSaving() {
      return this.runningOperation === 'save';
    },
    actionsDisabled() {
      return !!this.runningOperation;
    },
    valid() {
      return !!this.name;
    },
    isExistingTool() {
      return this.tool && this.tool.id;
    },
  },
  watch: {
    tool: {
      deep: true,
      handler: 'updateData'
    }
  },
  methods: {
    async setInactive() {
      this.runningOperation = 'changeActive';

      await machinesApi.deactivateTool(this.machineId, this.tool.id);
      await this.$store.dispatch('loadMachines');

      this.runningOperation = null;
      this.close();
    },
    async setActive() {
      this.runningOperation = 'changeActive';

      await machinesApi.reactivateTool(this.machineId, this.tool.id);
      await this.$store.dispatch('loadMachines');

      this.runningOperation = null;
      this.close();
    },
    async save() {
      const tool = {
        id: this.tool ? this.tool.id : null,
        name: this.name,
        shortName: this.shortName,
        description: this.description,
        isToolThatCanBeUsedWithAnyMachine: false
      };

      const apiOperation = tool.id ?
          machinesApi.editTool :
          machinesApi.createTool;
      this.runningOperation = 'save';

      await apiOperation(this.machineId, tool);
      await this.$store.dispatch('loadMachines');

      this.runningOperation = null;
      this.close();
    },
    close() {
      this.updateData(null);
      this.$emit('close');
    },
    updateData(data) {
      this.name = data ? data.name : '';
      this.shortName = data ? data.shortName : '';
      this.description = data ? data.description : '';
    },
  },
  data() {
    return {
      name: this.initialData ? this.initialData.name : '',
      shortName: this.initialData ? this.initialData.shortName : '',
      description: this.initialData ? this.initialData.description : '',
      rules: [val => !!val || 'Dieses Feld darf nicht leer sein'],
      runningOperation: null,
    };
  },
};
</script>
